var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":_vm.handleDs}},[_c('img',{staticClass:"touch-icon",attrs:{"src":require(`@/assets/touchFullscreen.png`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }